<template>
	<div class="dropdown-sort" :variant="variant" :id="uid">
		<div class="dropdown-sort__dropdown" ref="dropdownPosRef">
			<Dropdown
				:disabled="disabled"
				:defaultValue="defaultValue"
				:errorText="errorTextMessage || errorText"
				:helpText="helpText"
				:id="`${uid}_dd`"
				:label="label"
				:options="items"
				:renderList="false"
				:showClearSelectedButton="showClearSelectedButton"
				:toggleList="toggleMenu"
				:variant="variant"
				v-model="sortby"
			/>
		</div>
		<div class="dropdown-sort__single-sort">
			<SingleSort
				:disabled="disabled"
				:id="`${uid}_ss`"
				:variant="variant"
				v-model="sortdirection"
			>
				<template #label1>
					<i class="icon icon-sort-ascending"></i>
				</template>
				<template #label2>
					<i class="icon icon-sort-descending"></i>
				</template>
			</SingleSort>
		</div>
		<DropdownList
			ref="dropdownListRef"
			:autosuggestion="autosuggestion"
			:id="`${uid}_ddl`"
			:isOpen="isOpen"
			:multiSelect="multiSelect"
			:options="items"
			:variant="variant"
			v-model="sortby"
		/>
		<PopperPosition
			trackedRefName="dropdownPosRef"
			popoverRefName="dropdownListRef"
			placement="bottom-start"
			:popperVisible="isOpen"
			strategy="fixed"
			@popperMinWidthChanged="setpopperMinWidth"
			@positionUpdated="updateIconOrientation"
		/>
	</div>
</template>

<script>
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import SingleSort from '@/components/forms/single-sort/single-sort';
import PopperPosition from '@/components/visual/popper-position';
import dropdownMixins from '@/mixins/dropdown';
import { hasKeys } from '@/utils/function';

// mixins
import popperPositionMixin from '@/mixins/popper-position-mixin';

export default {
	name: 'DropdownSort',
	mixins: [dropdownMixins, popperPositionMixin],
	model: {
		prop: 'value',
		event: 'change'
	},
	components: {
		Dropdown,
		SingleSort,
		PopperPosition
	},
	data() {
		return {
			errorTextMessage: '',
			sortby: '',
			sortdirection: ''
		};
	},
	mounted() {
		//validation value
		if (this.value) {
			if (!hasKeys(this.value, ['sortby', 'sortdirection'])) {
				this.errorTextMessage =
					'`"sortby" and "sortdirection" properties are required.`';
			} else {
				this.sortby = this.value.sortby;
				this.sortdirection = this.value.sortdirection;
			}
		}
	},
	methods: {
		updateValue() {
			this.isOpen = false;
			this.$emit('change', {
				sortby: this.sortby,
				sortdirection: this.sortdirection
			});
		}
	},
	watch: {
		value() {
			this.sortby = this.value.sortby;
			this.sortdirection = this.value.sortdirection;
		},
		sortby() {
			this.updateValue();
		},
		sortdirection() {
			this.updateValue();
		}
	}
};
</script>

<style lang="scss">
/**
    * Dropdown sort styles
    * Can use SCSS variables = TRUE
*/
.dropdown-sort {
	display: inline-flex;
	position: relative;

	.dropdown-sort__dropdown {
		.dropdown {
			margin-left: 0;

			.dropdown__input-container {
				border-top-right-radius: 0;
				border-bottom-right-radius: 0;
				border-right: 0;
			}
		}
	}

	.dropdown-sort__single-sort {
		.single-sort {
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;

			.single-sort__label {
				display: inline-flex;
				align-items: center;
			}
		}
	}
}
</style>
